import React, { createContext, useState, useMemo } from 'react';

// only to check is search page open or not in global context of the app

export const SearchPageContext = createContext();


const SearchPageContextProvider = ({ children }) => {

    const [isOpen, setIsOpen] = useState(false);
    const [searchString, setSearchString] = useState('');

    const contextValue = useMemo(() => ({
        isOpen,
        setIsOpen,
        searchString,
        setSearchString
    }), [isOpen, setIsOpen, searchString, setSearchString]);

    return (
        <SearchPageContext.Provider value={contextValue}>
            {children}
        </SearchPageContext.Provider>
    );
}

export default SearchPageContextProvider;
